import "core-js/modules/es.array.some";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.split";
import Vue from "vue";
import Router from "vue-router";
import utils from "./common/utils";
import { GetToken, GetUserByBarcode } from "./api/login";
import { Toast } from "vant";
import store from "./store.js";
import { getUrlParams } from "./common/myFunc";
Vue.use(Router);
console.log("router.js");
console.log(process.env);
var router = new Router({
  mode: "history",
  routes: [{
    path: "/",
    redirect: "/authorization"
  }, {
    path: "/authorization",
    name: "",
    meta: {
      title: "身份验证"
    },
    component: function component() {
      return process.env.NODE_ENV == "development" ? import("./components/authorization_test.vue") : import("./components/authorization.vue");
    }
  }, {
    path: "/authorization_out",
    name: "",
    meta: {
      title: "身份验证"
    },
    component: function component() {
      return import("./components/authorization_out.vue");
    }
  }, {
    path: "/login",
    name: "",
    meta: {
      title: "登录"
    },
    component: function component() {
      return import("./components/login.vue");
    }
  }, {
    path: "/login_out",
    name: "",
    meta: {
      title: "登录"
    },
    component: function component() {
      return import("./components/login_out.vue");
    }
  }, {
    path: "/faceEntry",
    name: "",
    meta: {
      title: "人脸录入",
      requireAuth: true
    },
    component: function component() {
      return import("./components/personalCenter/faceEntry.vue");
    }
  }, {
    path: "/faceEntry/rules",
    name: "",
    meta: {
      title: "服务协议",
      requireAuth: true
    },
    component: function component() {
      return import("./components/personalCenter/faceRules.vue");
    }
  }, {
    path: "/card",
    name: "",
    meta: {
      title: "卡包",
      requireAuth: true,
      keepAlive: true
    },
    component: function component() {
      return import("./components/personalCenter/card/index.vue");
    }
  }, {
    path: "/cardlost",
    name: "",
    meta: {
      title: "卡挂失",
      requireAuth: true,
      keepAlive: true
    },
    component: function component() {
      return import("./components/personalCenter/card/index.vue");
    }
  }, {
    path: "/card/detail",
    name: "",
    meta: {
      title: "卡包",
      requireAuth: true
    },
    component: function component() {
      return import("./components/personalCenter/card/detail.vue");
    }
  }, {
    path: "/home",
    name: "",
    meta: {
      title: process.env.VUE_APP_HomePageTitle,
      requireAuth: true
    },
    component: function component() {
      return import("./components/home/index.vue");
    }
  }, {
    path: "/home_out",
    name: "",
    meta: {
      title: process.env.VUE_APP_HomePageTitle,
      requireAuth: true
    },
    component: function component() {
      return import("./components/home/index_out.vue");
    }
  }, {
    path: "/home/newsRecommedBook",
    name: "",
    meta: {
      title: "新书推荐",
      requireAuth: true
    },
    component: function component() {
      return import("./components/home/newRecomandList");
    }
  }, {
    path: "/mobile",
    name: "",
    meta: {
      title: process.env.VUE_APP_HomePageTitle,
      requireAuth: true
    },
    component: function component() {
      return import("./components/personalCenter/mobile.vue");
    }
  }, {
    path: "/moreApp",
    name: "",
    meta: {
      title: "更多应用",
      requireAuth: true
    },
    component: function component() {
      return import("./components/home/moreApp.vue");
    }
  }, {
    path: "/scanQRBorrow/scanQRlist",
    name: "",
    meta: {
      title: "扫码借书"
    },
    component: function component() {
      return import("./components/scan/scanQRBorrow/scanQRlist.vue");
    }
  }, {
    path: "/scanQRReturn/scanQRlist",
    name: "",
    meta: {
      title: "扫码还书"
    },
    component: function component() {
      return import("./components/scan/scanQRReturn/scanQRlist.vue");
    }
  }, {
    path: "/scan/status",
    name: "",
    meta: {
      title: "状态"
    },
    component: function component() {
      return import("./components/scan/status.vue");
    }
  }, {
    path: "/bookSearch/index",
    name: "",
    meta: {
      title: "图书检索",
      requireAuth: true,
      keepAlive: true
    },
    component: function component() {
      return import("./components/bookSearch/index.vue");
    }
  }, {
    path: "/bookSearch/searchDetail",
    name: "",
    meta: {
      title: "图书详情",
      requireAuth: true
    },
    component: function component() {
      return import("./components/bookSearch/searchDetail.vue");
    }
  }, {
    path: "/bookSearch/newsRecommedDetail",
    name: "",
    meta: {
      title: "图书推荐",
      requireAuth: true
    },
    component: function component() {
      return import("./components/bookSearch/newsRecommedDetail.vue");
    }
  }, {
    path: "/bookSearch/rinkBookDetail",
    name: "",
    meta: {
      title: "图书推荐",
      requireAuth: true
    },
    component: function component() {
      return import("./components/bookSearch/rinkBookDetail.vue");
    }
  }, {
    path: "/bookReservation/index",
    name: "",
    meta: {
      title: "图书预约",
      requireAuth: true,
      keepAlive: true
    },
    component: function component() {
      return import("./components/bookReservation/index.vue");
    }
  }, {
    path: "/searchReservation",
    name: "",
    meta: {
      title: "检索预约",
      requireAuth: true,
      keepAlive: true
    },
    component: function component() {
      return import("./components/bookReservation/searchReservation/search.vue");
    }
  }, {
    path: "/searchReservation/searchDetail",
    name: "",
    meta: {
      title: "资源详情",
      requireAuth: true
    },
    component: function component() {
      return import("./components/bookReservation/searchReservation/searchDetail.vue");
    }
  }, {
    path: "/mineReservation",
    name: "",
    meta: {
      title: "我的预约",
      requireAuth: true
    },
    component: function component() {
      return import("./components/bookReservation/mineReservation/mineReservation.vue");
    }
  }, {
    path: "/scanQR/scanQRList",
    name: "",
    meta: {
      title: "扫一扫详情",
      requireAuth: true
    },
    component: function component() {
      return import("./components/scanQR/scanQRlist.vue");
    }
  }, {
    path: "/scanQR/status",
    name: "",
    meta: {
      title: "状态"
    },
    component: function component() {
      return import("./components/scanQR/status.vue");
    }
  }, {
    path: "/scanQRHome/scanQRList",
    name: "",
    meta: {
      title: "扫一扫详情",
      requireAuth: true
    },
    component: function component() {
      return import("./components/scanQRHome/scanQRlist.vue");
    }
  }, {
    path: "/scanQRHome/status",
    name: "",
    meta: {
      title: "状态",
      requireAuth: true
    },
    component: function component() {
      return import("./components/scanQRHome/status.vue");
    }
  }, {
    path: "/bookReservation",
    name: "",
    meta: {
      title: "图书预约",
      requireAuth: true
    },
    component: function component() {
      return import("./components/bookReservation/index.vue");
    }
  }, {
    path: "/myLending/index",
    name: "",
    meta: {
      title: "我的在借",
      requireAuth: true,
      keepAlive: true
    },
    component: function component() {
      return import("./components/myLending/index.vue");
    }
  }, {
    path: "/borrowingBook",
    name: "",
    meta: {
      title: "我的在借",
      requireAuth: true,
      keepAlive: true
    },
    component: function component() {
      return import("./components/myLending/borrowingBook/borrowList.vue");
    }
  }, {
    path: "/borrowingBook/borrowListDetail",
    name: "borrowListDetail",
    meta: {
      title: "详情",
      requireAuth: true
    },
    component: function component() {
      return import("./components/myLending/borrowingBook/borrowListDetail");
    }
  }, {
    path: "/borrowingBook/writeBookReview",
    name: "",
    meta: {
      title: "校园书评",
      requireAuth: true
    },
    component: function component() {
      return import("./components/myLending/borrowingBook/writeBookReview");
    }
  }, {
    path: "/bookRenew",
    name: "",
    meta: {
      title: "图书续借",
      requireAuth: true,
      keepAlive: true
    },
    component: function component() {
      return import("./components/bookRenew/borrowList.vue");
    }
  }, {
    path: "/bookRenew/borrowListDetail",
    name: "",
    meta: {
      title: "详情",
      requireAuth: true
    },
    component: function component() {
      return import("./components/bookRenew/borrowListDetail.vue");
    }
  }, {
    path: "/bookRenew/writeBookReview",
    name: "",
    meta: {
      title: "校园书评",
      requireAuth: true
    },
    component: function component() {
      return import("./components/bookRenew/writeBookReview.vue");
    }
  }, {
    path: "/audit",
    name: "",
    meta: {
      title: "书评审核",
      requireAuth: true
    },
    component: function component() {
      return import("./components/bookReviewAudit/audit.vue");
    }
  }, {
    path: "/myReadBookReview",
    name: "",
    meta: {
      title: "我的书评",
      requireAuth: true
    },
    component: function component() {
      return import("./components/readBookReview/myReadBookReview.vue");
    }
  }, {
    path: "/evaluation",
    name: "evaluation",
    meta: {
      title: "评价",
      requireAuth: true,
      keepAlive: true
    },
    component: function component() {
      return import("./components/readBookReview/evaluation.vue");
    }
  }, {
    path: "/updateBookReview",
    name: "",
    meta: {
      title: "修改书评",
      requireAuth: true
    },
    component: function component() {
      return import("./components/readBookReview/updateBookReview.vue");
    }
  }, {
    path: "/auditSuccess",
    name: "",
    meta: {
      title: "书评审核成功",
      //书评上墙
      requireAuth: true
    },
    component: function component() {
      return import("./components/bookReviewAudit/success.vue");
    }
  }, {
    path: "/myReadBookReview",
    name: "",
    meta: {
      title: "我的书评",
      requireAuth: true
    },
    component: function component() {
      return import("./components/readBookReview/myReadBookReview.vue");
    }
  }, {
    path: "/borrowBookHistory",
    name: "",
    meta: {
      title: "我的历史",
      requireAuth: true,
      keepAlive: true
    },
    component: function component() {
      return import("./components/myLending/borrowBookHistory/borrowReturnList.vue");
    }
  }, {
    path: "/borrowBookHistory/borrowReturnListDetail",
    name: "",
    meta: {
      title: "详情",
      requireAuth: true
    },
    component: function component() {
      return import("./components/myLending/borrowBookHistory/borrowReturnListDetail.vue");
    }
  }, {
    path: "/bookLending/index",
    name: "",
    meta: {
      title: "图书外借",
      requireAuth: true,
      keepAlive: true
    },
    component: function component() {
      return import("./components/bookLending/index.vue");
    }
  }, {
    path: "/librarianManagement/index",
    name: "",
    meta: {
      title: "馆员管理",
      requireAuth: true
    },
    component: function component() {
      return import("./components/librarianManagement/index.vue");
    }
  }, {
    path: "/collectionLend",
    name: "",
    meta: {
      title: "本馆借出",
      requireAuth: true
    },
    component: function component() {
      return import("./components/librarianManagement/collectionLend/collectionList.vue");
    }
  }, {
    path: "/collectionLend/collectionDetail",
    name: "",
    meta: {
      title: "本馆借出",
      requireAuth: true
    },
    component: function component() {
      return import("./components/librarianManagement/collectionLend/collectionDetail.vue");
    }
  }, {
    //普通用户从首页进入最新外借时，进入此页面，此页面隐藏了借书人
    path: "/collectionLendUser",
    name: "",
    meta: {
      title: "本馆借出",
      requireAuth: true
    },
    component: function component() {
      return import("./components/librarianManagement/collectionLendUser/collectionList.vue");
    }
  }, {
    path: "/collectionLendUser/collectionDetail",
    name: "",
    meta: {
      title: "本馆借出",
      requireAuth: true
    },
    component: function component() {
      return import("./components/librarianManagement/collectionLendUser/collectionDetail.vue");
    }
  }, {
    path: "/reservationManage",
    name: "",
    meta: {
      title: "预约管理",
      requireAuth: true
    },
    component: function component() {
      return import("./components/librarianManagement/reservationManage/reservationManage.vue");
    }
  }, {
    path: "/alarmRecord",
    name: "",
    meta: {
      title: "报警记录",
      requireAuth: true
    },
    component: function component() {
      return import("./components/librarianManagement/alarmRecord/index.vue");
    }
  }, {
    path: "/alarmRecord/alarmRecordDetails",
    name: "",
    meta: {
      title: "资源详情",
      requireAuth: true
    },
    component: function component() {
      return import("./components/librarianManagement/alarmRecord/alarmRecordDetails.vue");
    }
  }, {
    path: "/recommendManage",
    name: "",
    meta: {
      title: "荐购管理",
      requireAuth: true,
      keepAlive: true
    },
    component: function component() {
      return import("./components/librarianManagement/recommendManage/index.vue");
    }
  }, {
    path: "/recommendManage/detail",
    name: "",
    meta: {
      title: "荐购管理",
      requireAuth: true // keepAlive: true

    },
    component: function component() {
      return import("./components/librarianManagement/recommendManage/detail.vue");
    }
  }, {
    path: "/donateApp/index",
    name: "",
    meta: {
      title: "赠书传递",
      requireAuth: true
    },
    component: function component() {
      return import("./components/donateApp/index.vue");
    }
  }, {
    path: "/donateApp/donateBooks",
    name: "",
    meta: {
      title: "全部赠书",
      requireAuth: true,
      keepAlive: true
    },
    component: function component() {
      return import("./components/donateApp/donateBooks");
    }
  }, {
    path: "/donateApp/publish",
    name: "",
    meta: {
      title: "发布赠书",
      requireAuth: true
    },
    component: function component() {
      return import("./components/donateApp/publish.vue");
    }
  }, {
    path: "/donateApp/bookDetail",
    name: "",
    meta: {
      title: "资源详情",
      requireAuth: true
    },
    component: function component() {
      return import("./components/donateApp/bookDetail.vue");
    }
  }, {
    path: "/donateApp/mineDonate",
    name: "",
    meta: {
      title: "我的捐赠",
      requireAuth: true
    },
    component: function component() {
      return import("./components/donateApp/mineDonate.vue");
    }
  }, {
    path: "/donateApp/mineDonateDetails",
    name: "",
    meta: {
      title: "我的捐赠",
      requireAuth: true
    },
    component: function component() {
      return import("./components/donateApp/mineDonateDetails.vue");
    }
  }, {
    path: "/donateApp/yuyueManage",
    name: "",
    meta: {
      title: "预约管理",
      requireAuth: true
    },
    component: function component() {
      return import("./components/donateApp/yuyueManage.vue");
    }
  }, {
    path: "/donateApp/yuyueApplyDetails",
    name: "",
    meta: {
      title: "详情",
      requireAuth: true
    },
    component: function component() {
      return import("./components/donateApp/yuyueApplyDetails.vue");
    }
  }, {
    path: "/donateApp/yuyueReceiveDetails",
    name: "",
    meta: {
      title: "详情",
      requireAuth: true
    },
    component: function component() {
      return import("./components/donateApp/yuyueReceiveDetails.vue");
    }
  }, {
    path: "/donateApp/scanQRlist",
    name: "",
    meta: {
      title: "扫一扫详情",
      requireAuth: true
    },
    component: function component() {
      return import("./components/donateApp/scanQRlist.vue");
    }
  }, {
    path: "/donateApp/status",
    name: "",
    meta: {
      title: "状态",
      requireAuth: true
    },
    component: function component() {
      return import("./components/donateApp/status.vue");
    }
  }, {
    path: "/donateApp/mineDonate",
    name: "",
    meta: {
      title: "我的捐赠",
      requireAuth: true
    },
    component: function component() {
      return import("./components/donateApp/mineDonate.vue");
    }
  }, {
    path: "/activityApp/index",
    name: "",
    meta: {
      title: "阅读活动",
      requireAuth: true
    },
    component: function component() {
      return import("./components/activityApp/index.vue");
    }
  }, {
    path: "/activityApp/publish",
    name: "",
    meta: {
      title: "活动发布",
      requireAuth: true
    },
    component: function component() {
      return import("./components/activityApp/publish.vue");
    }
  }, {
    path: "/activityAudit",
    name: "",
    meta: {
      title: "活动审核",
      requireAuth: true
    },
    component: function component() {
      return import("./components/activityAudit/index.vue");
    }
  }, {
    path: "/activityApp/details",
    name: "",
    meta: {
      title: "详情",
      requireAuth: true
    },
    component: function component() {
      return import("./components/activityApp/details.vue");
    }
  }, {
    path: "/activityApp/endDetails",
    name: "",
    meta: {
      title: "详情",
      requireAuth: true
    },
    component: function component() {
      return import("./components/activityApp/endDetails.vue");
    }
  }, {
    path: "/activityApp/upload",
    name: "",
    meta: {
      title: "上传",
      requireAuth: true
    },
    component: function component() {
      return import("./components/activityApp/upload.vue");
    }
  }, {
    path: "/activityApp/mineActivity",
    name: "",
    meta: {
      title: "我的活动",
      requireAuth: true,
      keepAlive: true
    },
    component: function component() {
      return import("./components/activityApp/mineActivity.vue");
    }
  }, {
    path: "/activityApp/people",
    name: "",
    meta: {
      title: "人员信息",
      requireAuth: true
    },
    component: function component() {
      return import("./components/activityApp/people.vue");
    }
  }, {
    path: "/activityAppStu",
    //根据权限划分（没有我的发布）
    name: "",
    meta: {
      title: "阅读活动",
      requireAuth: true
    },
    component: function component() {
      return import("./components/activityAppStudent/index.vue");
    }
  }, {
    path: "/knowledgeCinema",
    name: "",
    meta: {
      // title: '知识影院',
      requireAuth: true,
      keepAlive: true
    },
    component: function component() {
      return import("./components/knowledgeCinema/index.vue");
    }
  }, {
    path: "/knowledgeCinema/details",
    name: "",
    meta: {
      title: "详情" // requireAuth: true

    },
    component: function component() {
      return import("./components/knowledgeCinema/details.vue");
    }
  }, {
    path: "/knowledgeCinema/order",
    name: "",
    meta: {
      title: "我的点播",
      requireAuth: true
    },
    component: function component() {
      return import("./components/knowledgeCinema/order.vue");
    }
  }, {
    path: "/knowledgeCinema/status",
    name: "",
    meta: {
      requireAuth: true
    },
    component: function component() {
      return import("./components/knowledgeCinema/status.vue");
    }
  }, {
    path: "/expressService",
    name: "expressService",
    meta: {
      requireAuth: true,
      title: "快递服务"
    },
    component: function component() {
      return import("./components/expressService/index.vue");
    }
  }, {
    path: "/expressService/address",
    name: "",
    meta: {
      requireAuth: true,
      title: "订单信息"
    },
    component: function component() {
      return import("./components/expressService/address.vue");
    }
  }, {
    path: "/expressService/order",
    name: "",
    meta: {
      requireAuth: true,
      title: "我的订单"
    },
    component: function component() {
      return import("./components/expressService/order.vue");
    }
  }, {
    path: "/expressService/orderDetail",
    name: "",
    meta: {
      requireAuth: true,
      title: "订单详情"
    },
    component: function component() {
      return import("./components/expressService/orderDetail.vue");
    }
  }, {
    path: "/expressService/success",
    name: "",
    meta: {
      requireAuth: true,
      title: "状态"
    },
    component: function component() {
      return import("./components/expressService/success.vue");
    }
  }, {
    path: "/expressService/fail",
    name: "",
    meta: {
      requireAuth: true,
      title: "状态"
    },
    component: function component() {
      return import("./components/expressService/fail.vue");
    }
  }, {
    path: "/expressService/logistics",
    name: "",
    meta: {
      requireAuth: true,
      title: "查看物流"
    },
    component: function component() {
      return import("./components/expressService/logistics.vue");
    }
  }, {
    path: "/crossSchoolSearch",
    name: "",
    meta: {
      title: "校际联盟",
      requireAuth: true
    },
    component: function component() {
      return import("./components/crossSchoolSearch/index.vue");
    }
  }, {
    path: "/crossSchoolSearch/searchDetail",
    name: "",
    meta: {
      title: "资源详情",
      requireAuth: true
    },
    component: function component() {
      return import("./components/crossSchoolSearch/searchDetail.vue");
    }
  }, {
    path: "/readingReport",
    name: "",
    meta: {
      title: "阅读报告",
      requireAuth: true
    },
    component: function component() {
      return import("./components/readingReport/index.vue");
    }
  }, {
    path: "/userCode",
    name: "",
    meta: {
      title: "声阅用户代码查询",
      requireAuth: true
    },
    component: function component() {
      return import("./components/userCode/index.vue");
    }
  }, {
    path: "/oauth",
    name: "身份认证",
    meta: {
      title: ""
    },
    component: function component() {
      return import("./components/oauth.vue");
    }
  }, {
    path: "/crossSchoolSearch/search",
    name: "",
    meta: {
      title: "校际联盟检索预约",
      requireAuth: true,
      keepAlive: true
    },
    component: function component() {
      return import("./components/crossSchoolSearch/search.vue");
    }
  }, {
    path: "/crossSchoolSearch/annual",
    name: "",
    meta: {
      title: "校际联盟年报管理",
      requireAuth: true
    },
    component: function component() {
      return import("./components/crossSchoolSearch/annual.vue");
    }
  }, {
    path: "/crossSchoolSearch/loanRecordList",
    name: "",
    meta: {
      title: "校际联盟外借记录",
      requireAuth: true // keepAlive: true

    },
    component: function component() {
      return import("./components/crossSchoolSearch/loanRecordList.vue");
    }
  }, {
    path: "/eduManage",
    name: "",
    meta: {
      title: "德育管理"
    },
    component: function component() {
      return import("./components/eduManage/index.vue");
    }
  }, {
    path: "/eduManage/list",
    name: "",
    meta: {
      title: "德育管理"
    },
    component: function component() {
      return import("./components/eduManage/list.vue");
    }
  }, {
    path: "/eduManage/mana",
    name: "",
    meta: {
      title: "德育管理"
    },
    component: function component() {
      return import("./components/eduManage/mana.vue");
    }
  }, {
    path: "/eduManage/person",
    name: "",
    meta: {
      title: "德育管理"
    },
    component: function component() {
      return import("./components/eduManage/person.vue");
    }
  }, {
    path: "/application/newBookShow",
    name: "",
    meta: {
      title: "新书展示"
    },
    component: function component() {
      return import("./application/paintingWall/newBookShow.vue");
    }
  }, {
    path: "/application/bookReview",
    name: "",
    meta: {
      title: "校园书评"
    },
    component: function component() {
      return import("./application/paintingWall/bookReview.vue");
    }
  }, {
    path: "/application/paintingWall",
    name: "",
    meta: {
      title: "三个项目"
    },
    component: function component() {
      return import("./application/paintingWall/paintingWall_all.vue");
    }
  }, {
    path: "/application/screen",
    name: "",
    meta: {
      title: ""
    },
    component: function component() {
      return import("./application/screen/index.vue");
    }
  }, {
    path: "/knowledgePoster",
    meta: {
      title: "知识海报",
      requireAuth: true
    },
    redirect: "/knowledgePoster/equip",
    component: function component() {
      return import("./components/knowledgePoster/index.vue");
    },
    children: [{
      path: "/knowledgePoster/equip",
      component: function component() {
        return import("./components/knowledgePoster/equip.vue");
      }
    }, {
      path: "/knowledgePoster/template",
      component: function component() {
        return import("./components/knowledgePoster/template.vue");
      }
    }, {
      path: "/knowledgePoster/imageTemplate",
      component: function component() {
        return import("./components/knowledgePoster/imageTemplate/index.vue");
      }
    }, {
      path: "/knowledgePoster/videoTemplate",
      component: function component() {
        return import("./components/knowledgePoster/videoTemplate/index.vue");
      }
    }, {
      path: "/knowledgePoster/customizeTemplate",
      component: function component() {
        return import("./components/knowledgePoster/customizeTemplate/index.vue");
      }
    }, {
      path: "/knowledgePoster/device",
      component: function component() {
        return import("./components/knowledgePoster/device.vue");
      }
    }, {
      path: "/knowledgePoster/success",
      component: function component() {
        return import("./components/knowledgePoster/success.vue");
      }
    }]
  }, {
    path: "/bookRecommendation",
    name: "",
    meta: {
      title: "图书荐购",
      requireAuth: true,
      keepAlive: true
    },
    component: function component() {
      return import("./components/bookRecommendation/index.vue");
    }
  }, {
    path: "/bookRecommendation/public",
    name: "",
    meta: {
      title: "图书荐购",
      requireAuth: true
    },
    component: function component() {
      return import("./components/bookRecommendation/public.vue");
    }
  }, {
    path: "/bookRecommendation/list",
    name: "",
    meta: {
      title: "图书荐购",
      requireAuth: true
    },
    component: function component() {
      return import("./components/bookRecommendation/list.vue");
    }
  }, //扫码查重
  {
    path: "/scanCodeCheck",
    name: "",
    meta: {
      title: "扫码查重",
      requireAuth: true
    },
    component: function component() {
      return import("./components/scanCodeCheck/index.vue");
    }
  }, {
    path: "/checklist",
    name: "",
    meta: {
      title: "查重列表"
    },
    component: function component() {
      return import("./components/scanCodeCheck/checkList.vue");
    }
  }, //漂流书柜
  {
    path: "/floatingBookcase",
    name: "",
    meta: {
      title: "漂流书柜",
      requireAuth: true
    },
    component: function component() {
      return import("./components/floatingBookcase/index.vue");
    }
  }, {
    path: "/questionnaire",
    name: "",
    meta: {
      title: "问卷调查",
      requireAuth: true
    },
    component: function component() {
      return import("./components/questionnaire/index.vue");
    }
  }, {
    path: "/questionnaire/submission",
    name: "",
    meta: {
      title: "问卷调查填写",
      requireAuth: true
    },
    component: function component() {
      return import("./components/questionnaire/submission.vue");
    }
  }, {
    path: "/questionnaire/statistics",
    name: "",
    meta: {
      title: "问卷调查统计",
      requireAuth: true
    },
    component: function component() {
      return import("./components/questionnaire/statistics.vue");
    }
  }, {
    path: "/questionnaire/success",
    name: "",
    meta: {
      title: "问卷调查提交成功",
      requireAuth: true
    },
    component: function component() {
      return import("./components/questionnaire/success.vue");
    }
  }, //阅读圈
  {
    path: "/readingCircle/readingcircle",
    name: "",
    meta: {
      title: "阅读圈",
      requireAuth: true
    },
    component: function component() {
      return import("./components/readingCircle/readingcircle.vue");
    }
  }, {
    path: "/readingCircle/publishCircle",
    name: "",
    meta: {
      title: "发表阅读圈",
      requireAuth: true
    },
    component: function component() {
      return import("./components/readingCircle/publishCircle.vue");
    }
  }, {
    path: "/readingCircle/myReadingcircle",
    name: "",
    meta: {
      title: "我的阅读圈",
      requireAuth: true
    },
    component: function component() {
      return import("./components/readingCircle/myReadingcircle.vue");
    }
  }, {
    path: "/readingCircle/tape",
    name: "",
    meta: {
      title: "录音",
      requireAuth: true
    },
    component: function component() {
      return import("./components/readingCircle/tape.vue");
    }
  }, {
    path: "/readingPoints",
    name: "",
    meta: {
      title: "阅读积分",
      requireAuth: true
    },
    component: function component() {
      return import("./components/readingPoints/index.vue");
    }
  }, {
    path: "/readingPoints/details",
    name: "",
    meta: {
      title: "积分详情",
      requireAuth: true
    },
    component: function component() {
      return import("./components/readingPoints/details.vue");
    }
  }, {
    path: "/readingPoints/goods",
    name: "",
    meta: {
      title: "积分商城",
      requireAuth: true
    },
    component: function component() {
      return import("./components/readingPoints/goods.vue");
    }
  }, {
    path: "/readingPoints/records",
    name: "",
    meta: {
      title: "积分明细",
      requireAuth: true
    },
    component: function component() {
      return import("./components/readingPoints/records.vue");
    }
  }, {
    path: "/readingPoints/ticket",
    name: "",
    meta: {
      title: "我的票券",
      requireAuth: true
    },
    component: function component() {
      return import("./components/readingPoints/ticket.vue");
    }
  }, {
    path: "/readingPoints/order",
    name: "",
    meta: {
      title: "我的预约",
      requireAuth: true
    },
    component: function component() {
      return import("./components/readingPoints/order.vue");
    }
  }, {
    path: "/readingPoints/rule",
    name: "",
    meta: {
      title: "积分规则",
      requireAuth: true
    },
    component: function component() {
      return import("./components/readingPoints/rule.vue");
    }
  }, {
    path: "/readPointMana",
    name: "",
    meta: {
      title: "积分管理",
      requireAuth: true
    },
    component: function component() {
      return import("./components/readPointMana/index.vue");
    }
  }, {
    path: "/readPointMana/create",
    name: "",
    meta: {
      title: "票券创建",
      requireAuth: true
    },
    component: function component() {
      return import("./components/readPointMana/create.vue");
    }
  }, {
    path: "/readPointMana/order",
    name: "",
    meta: {
      title: "预约记录",
      requireAuth: true
    },
    component: function component() {
      return import("./components/readPointMana/order.vue");
    }
  }, {
    path: "/readPointMana/provide",
    name: "",
    meta: {
      title: "票券发放",
      requireAuth: true
    },
    component: function component() {
      return import("./components/readPointMana/provide.vue");
    }
  }, {
    path: "/readPointMana/goods",
    name: "",
    meta: {
      title: "在架物品",
      requireAuth: true
    },
    component: function component() {
      return import("./components/readPointMana/goods.vue");
    }
  }, {
    path: "/readPointMana/goodAdd",
    name: "",
    meta: {
      title: "添加物品",
      requireAuth: true
    },
    component: function component() {
      return import("./components/readPointMana/goodAdd.vue");
    }
  }, {
    path: "/readPointMana/goodEdit",
    name: "",
    meta: {
      title: "编辑物品",
      requireAuth: true
    },
    component: function component() {
      return import("./components/readPointMana/goodEdit.vue");
    }
  }, {
    path: "/readPointMana/details",
    name: "",
    meta: {
      title: "物品详情",
      requireAuth: true
    },
    component: function component() {
      return import("./components/readPointMana/details.vue");
    }
  }, {
    path: "/pointRink",
    name: "",
    meta: {
      title: "积分排行",
      requireAuth: true
    },
    component: function component() {
      return import("./components/pointRink/index.vue");
    }
  }, {
    path: "/pointRinkH",
    name: "",
    meta: {
      title: "积分排行",
      requireAuth: true
    },
    component: function component() {
      return import("./components/pointRink/index-h.vue");
    }
  }, {
    path: "/selfCheck",
    name: "",
    meta: {
      title: "书架清点",
      requireAuth: true
    },
    component: function component() {
      return import("./components/selfCheck/index.vue");
    }
  }, {
    path: "/readerCollection",
    name: "",
    meta: {
      title: "我的收藏",
      requireAuth: true
    },
    component: function component() {
      return import("./components/readerCollection/index.vue");
    }
  }, {
    path: "/scanReBorrow/scanQRlist",
    name: "",
    meta: {
      title: "扫码代借",
      requireAuth: true
    },
    component: function component() {
      return import("./components/librarianManagement/scanReBorrow/scanQRlist.vue");
    }
  }, {
    path: "/scanReBorrow/status",
    name: "",
    meta: {
      title: "扫码代借",
      requireAuth: true
    },
    component: function component() {
      return import("./components/librarianManagement/scanReBorrow/status.vue");
    }
  }, {
    path: "/readBookReview",
    name: "",
    meta: {
      title: "阅读书评",
      requireAuth: true
    },
    component: function component() {
      return import("./components/readBookReview/index.vue");
    }
  }, //阅读圈审核
  {
    path: "/readcircleaudit",
    name: "",
    meta: {
      title: "阅读圈审核",
      requireAuth: true
    },
    component: function component() {
      return import("./components/readCircleAudit/index.vue");
    }
  }, //二次文献
  {
    path: "/secondarySource",
    name: "",
    meta: {
      title: "二次文献",
      requireAuth: true
    },
    component: function component() {
      return import("./components/secondarySource/index.vue");
    }
  }, {
    path: "/sourceDetail",
    name: "",
    meta: {
      title: "二次文献",
      requireAuth: true
    },
    component: function component() {
      return import("./components/secondarySource/detail.vue");
    }
  }, {
    path: "/sourceCatalogue",
    name: "",
    meta: {
      title: "二次文献目录",
      requireAuth: true
    },
    component: function component() {
      return import("./components/secondarySource/catalogue.vue");
    }
  }, {
    path: "/sourceIssueDetail",
    name: "",
    meta: {
      title: "二次文献期内容",
      requireAuth: true
    },
    component: function component() {
      return import("./components/secondarySource/content.vue");
    }
  }, //座位預約
  {
    path: "/seatReservation",
    name: "",
    meta: {
      title: "座位预约",
      requireAuth: true
    },
    component: function component() {
      return import("./components/seatReservation/index.vue");
    }
  }, {
    path: "/mySeatReservation",
    name: "",
    meta: {
      title: "我的座位预约",
      requireAuth: true
    },
    component: function component() {
      return import("./components/seatReservation/mySeatReserv.vue");
    }
  }, {
    path: "/seatManage",
    name: "",
    meta: {
      title: "座位预约管理",
      requireAuth: true
    },
    component: function component() {
      return import("./components/seatManage/index.vue");
    }
  }, {
    path: "/addSeat",
    name: "",
    meta: {
      title: "新增场馆",
      requireAuth: true
    },
    component: function component() {
      return import("./components/seatManage/add.vue");
    }
  }, {
    path: "/editSeat",
    name: "",
    meta: {
      title: "修改场馆",
      requireAuth: true
    },
    component: function component() {
      return import("./components/seatManage/edit.vue");
    }
  }, //数字资源
  {
    path: "/digitalResource",
    name: "",
    meta: {
      title: "数字资源",
      requireAuth: true
    },
    component: function component() {
      return import("./components/digitalResource/index.vue");
    }
  }, {
    path: "/digitalResource/index1",
    name: "",
    meta: {
      title: "数字资源",
      requireAuth: true
    },
    component: function component() {
      return import("./components/digitalResource/index1.vue");
    }
  }, {
    path: "/digitalResource/index2",
    name: "",
    meta: {
      title: "数字资源",
      requireAuth: true
    },
    component: function component() {
      return import("./components/digitalResource/index2.vue");
    }
  }, {
    path: "/upload-test",
    name: "",
    meta: {
      title: "测试上传",
      requireAuth: true
    },
    component: function component() {
      return import("./components/upload-test/index.vue");
    }
  }, //消息推送开始
  {
    path: "/msgPush/activityDetail_TS",
    name: "",
    meta: {
      title: "详情",
      requireAuth: true
    },
    component: function component() {
      return import("./components/msgPush/activityDetail_TS.vue");
    }
  }, {
    path: "/msgPush/activityEndDetail_TS",
    name: "",
    meta: {
      title: "详情",
      requireAuth: true
    },
    component: function component() {
      return import("./components/msgPush/activityEndDetail_TS.vue");
    }
  }, {
    path: "/msgPush/activityEndDetail_TS",
    name: "",
    meta: {
      title: "详情",
      requireAuth: true
    },
    component: function component() {
      return import("./components/msgPush/activityEndDetail_TS.vue");
    }
  }, {
    path: "/msgPush/activityAuditDetail_TS",
    name: "",
    meta: {
      title: "活动审核",
      requireAuth: true
    },
    component: function component() {
      return import("./components/msgPush/activityAuditDetail_TS.vue");
    }
  }, {
    path: "/msgPush/activityPublish_TS",
    name: "",
    meta: {
      title: "活动编辑",
      requireAuth: true
    },
    component: function component() {
      return import("./components/msgPush/activityPublish_TS.vue");
    }
  }, {
    path: "/msgPush/alarmRecordDetails_TS",
    name: "",
    meta: {
      title: "资源详情",
      requireAuth: true
    },
    component: function component() {
      return import("./components/msgPush/alarmRecordDetails_TS.vue");
    }
  }, {
    path: "/msgPush/borrowReturnListDetail_TS",
    name: "",
    meta: {
      title: "详情",
      requireAuth: true
    },
    component: function component() {
      return import("./components/msgPush/borrowReturnListDetail_TS.vue");
    }
  }, {
    path: "/msgPush/reservationManage_TS",
    name: "",
    meta: {
      title: "图书预约",
      requireAuth: true
    },
    component: function component() {
      return import("./components/msgPush/reservationManage_TS.vue");
    }
  }, {
    path: "/msgPush/searchDetail_TS",
    name: "",
    meta: {
      title: "详情",
      requireAuth: true
    },
    component: function component() {
      return import("./components/msgPush/searchDetail_TS.vue");
    }
  }, {
    path: "/msgPush/yuyueApplyDetails_TS",
    name: "",
    meta: {
      title: "详情",
      requireAuth: true
    },
    component: function component() {
      return import("./components/msgPush/yuyueApplyDetails_TS.vue");
    }
  }, {
    path: "/msgPush/yuyueReceiveDetails_TS",
    name: "",
    meta: {
      title: "详情",
      requireAuth: true
    },
    component: function component() {
      return import("./components/msgPush/yuyueReceiveDetails_TS.vue");
    }
  }, {
    path: "/unauth",
    name: "",
    meta: {
      title: "授权"
    },
    component: function component() {
      return import("./components/unauth.vue");
    }
  }, {
    path: "/readinglist",
    name: "readinglist",
    meta: {
      title: "阅读书单",
      requireAuth: true
    },
    component: function component() {
      return import("./components/readinglist/index.vue");
    }
  }, {
    path: "/readinglist/list",
    name: "readinglistlist",
    meta: {
      title: "阅读书单",
      requireAuth: true
    },
    component: function component() {
      return import("./components/readinglist/index.vue");
    }
  }, // 消息推送结束
  //校阅通外部应用开始
  {
    path: "/application/pbl",
    name: "",
    meta: {
      title: "作品流"
    },
    component: function component() {
      return import("./application/pbl/index.vue");
    }
  }, {
    path: "/application/knowledgeCiname",
    name: "",
    meta: {
      title: "知识影院"
    },
    component: function component() {
      return import("./application/knowledgeCiname/index.vue");
    }
  }, {
    path: "/application/poster",
    name: "",
    meta: {
      title: "知识海报"
    },
    component: function component() {
      return import("./application/poster/index.vue");
    }
  }, {
    path: "/application/details",
    name: "",
    meta: {
      title: "详情"
    },
    component: function component() {
      return import("./application/detail.vue");
    }
  }, {
    path: "/application/dataAnalysis",
    name: "",
    meta: {
      title: "数据分析"
    },
    component: function component() {
      return import("./application/dataAnalysis/index.vue");
    }
  }, {
    path: "/application/bubbleWall",
    name: "",
    meta: {
      title: "气泡墙"
    },
    component: function component() {
      return import("./application/bubbleWall/index.vue");
    }
  }, {
    path: "/application/paintingWall",
    name: "",
    meta: {
      title: "三个项目"
    },
    component: function component() {
      return import("./application/paintingWall/paintingWall_all.vue");
    }
  }, {
    path: "/application/seatReservation",
    name: "",
    meta: {
      title: "座位预约大屏"
    },
    component: function component() {
      return import("./application/SeatReservation/index.vue");
    }
  } //校阅通外部应用结束
  ]
});
router.beforeEach(function (to, from, next) {
  var DeviceType = to.query.DeviceType;
  var Code = to.query.CompanyCode;
  var DeviceCode = to.query.Code;
  var UserBarCode = to.query.UserBarCode;
  utils.setSession("prevurl", from.fullPath);

  if (window.entryUrl === undefined) {
    window.entryUrl = window.location.href.split("#")[0];
  }

  if (to.matched.some(function (res) {
    return res.meta.requireAuth;
  })) {
    // 验证是否需要登陆
    if (utils.getSession("token")) {
      // 查询本地存储信息是否已经登陆
      next();
    } else {
      if (DeviceType == "Android" || DeviceCode) {
        if (Code) {
          //安卓进入带参数
          GetToken({
            Corpid: process.env.VUE_APP_Corpid,
            Secret: process.env.VUE_APP_Secret
          }).then(function (data) {
            if (!data.iserror) {
              utils.setSession("token", data.data.access_token);
              utils.setSession("Code", Code); //将Code存入到header中

              if (UserBarCode) {
                GetUserByBarcode({
                  UserBarCode: UserBarCode
                }).then(function (data) {
                  if (!data.iserror) {
                    store.state.userInfo = data.data;
                    utils.setSession("userInfo", data.data);
                    next();
                  }
                });
              } else {
                next();
              }
            }
          });
        }
      } else {
        next({
          path: "/authorization",
          // 未登录则跳转至login页面。如果是详情页面进入的，就没办法判断当前是外部链接还是内部链接，就没办法决定此处跳到authorization还是authorization_out。所以未绑定的用户点击别人
          //分享的页面直接进入login页面就没办法实现
          query: {
            redirectM: to.fullPath
          } // 登陆成功后回到当前页面，这里传值给login页面，to.fullPath为当前点击的页面

        });
      }
    }
  } else {
    // console.log('000')
    next();
  }
});
export default router;